import { RouterProvider } from 'react-router'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ErrorBoundary } from './ErrorBoundary/ErrorBoundary'
import { ErrorPage } from './ErrorBoundary/ErrorPage'
import { Suspense, useEffect, useState, type FC } from 'react'
import { isTMA, retrieveLaunchParams } from '@telegram-apps/sdk'
import { CustomLoader } from './@common/CustomLoader'
import { NotInTelegram } from './NotInTelegram'
import { router } from './router'
import { parseStartParam } from '@/pages/Onboarding/utils/parseStartParam'

const queryClient = new QueryClient()

// Проверяет startapp и редиректит на /onboarding если нужно
function handleOnboardingDeeplink() {
  try {
    const launchParams = retrieveLaunchParams()
    const startParam = launchParams?.startParam

    if (startParam && startParam !== 'debug') {
      const parsed = parseStartParam(startParam)
      if (parsed && window.location.pathname !== '/onboarding') {
        // Формируем URL с параметрами из startapp
        const params = new URLSearchParams()
        params.set('step', parsed.step)
        if (parsed.type) params.set('type', parsed.type)
        if (parsed.entityId) params.set('entityId', parsed.entityId)

        window.location.href = `/onboarding?${params.toString()}`
        return true
      }
    }
  } catch (e) {
    console.warn('[Root] Failed to handle onboarding deeplink:', e)
  }
  return false
}

async function checkIsTelegram() {
  const result = await isTMA()
  return result
}

export const Root: FC = () => {
  const [isTelegram, setIsTelegram] = useState<boolean | null>(null)
  const [isRedirecting, setIsRedirecting] = useState(false)

  useEffect(() => {
    // Проверяем deeplink для onboarding
    if (handleOnboardingDeeplink()) {
      setIsRedirecting(true)
      return
    }

    async function verifyTelegram() {
      const result = await checkIsTelegram()
      setIsTelegram(result)
    }
    verifyTelegram()
  }, [])

  if (isRedirecting || isTelegram === null) {
    return <CustomLoader /> // Пока проверка не завершена или идёт редирект, показываем лоадер
  }

  if (!isTelegram) {
    return <NotInTelegram /> // Показываем окно вместо ошибки
  }

  return (
    <ErrorBoundary fallback={ErrorPage}>
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={<CustomLoader />}>
          <RouterProvider router={router} />
        </Suspense>
      </QueryClientProvider>
    </ErrorBoundary>
  )
}
